export const SCHEDULE_ITEMS_FETCH = "SCHEDULE_ITEMS_FETCH"
export const SCHEDULE_ITEMS_FETCHED = "SCHEDULE_ITEMS_FETCHED"
export const SCHEDULE_ITEMS_FETCH_ERROR = "SCHEDULE_ITEMS_FETCH_ERROR"

// CUD - Create Update Delete
export const SCHEDULE_ITEM_CUD = "SCHEDULE_ITEM_CUD"
export const SCHEDULE_ITEM_CUD_SUCCESS = "SCHEDULE_ITEM_CUD_SUCCESS"
export const SCHEDULE_ITEM_CUD_ERROR = "SCHEDULE_ITEM_CUD_ERROR"


export function scheduleItemsFetch() {
    return {
        type: SCHEDULE_ITEMS_FETCH
    }
}

export function scheduleItemsFetched(data) {
    return {
        type: SCHEDULE_ITEMS_FETCHED,
        payload: data
    }
}

export function scheduleItemsFetchError(error) {
    return {
        type: SCHEDULE_ITEMS_FETCH_ERROR,
        payload: error
    }
}

export function scheduleItemCud(collection, action, id, data) {
    return {
        type: SCHEDULE_ITEM_CUD,
        payload: {
            collection,
            action,
            id,
            data
        }
    }
}

export function scheduleItemCudSuccess(data) {
    return {
        type: SCHEDULE_ITEM_CUD_SUCCESS,
        payload: data
    }
}

export function scheduleItemCudError(error) {
    return {
        type: SCHEDULE_ITEM_CUD_ERROR,
        payload: error
    }
}
